import {
    PRODUCT_FILTER,
    PRODUCT_ITEMGROUP_FILTER,
    PRODUCT_PRODUCTGROUP_FILTER,
    PRODUCT_PRODUCTLINE_FILTER,
    PRODUCT_PRODUCTTYPE_FILTER,
    PRODUCT_PRODUCTVATTYPE_FILTER,
    PRODUCT_DISPLAY_FILTER,
    PRODUCT_AMOUNT_FILTER,
    PRODUCT_SALE_MONTH,
    PRODUCT_NEW_PRODUCT,
    PRODUCT_DISPLAYSALESMAN_FILTER,
    PRODUCT_PRODUCTGROUP_FOCUS_FILTER,
    PRODUCT_PRODUCTLINE_FOCUS_FILTER,
    PRODUCT_PRODUCTTYPE_FOCUS_FILTER,
    PRODUCT_SEARCH_TRIGGER
} from '../constants/ActionTypes';

export const selectProduct = payload => {
    return {
        type: PRODUCT_FILTER,
        payload
    }
}

export const productItemGroupFilter = payload => {
    return {
        type: PRODUCT_ITEMGROUP_FILTER,
        payload
    }
}

export const productProductGroupFilter = payload => {
    return {
        type: PRODUCT_PRODUCTGROUP_FILTER,
        payload
    }
}

export const productProductLineFilter = payload => {
    return {
        type: PRODUCT_PRODUCTLINE_FILTER,
        payload
    }
}

export const productProductTypeFilter = payload => {
    return {
        type: PRODUCT_PRODUCTTYPE_FILTER,
        payload
    }
}

export const productProductVatTypeFilter = payload => {
    return {
        type: PRODUCT_PRODUCTVATTYPE_FILTER,
        payload
    }
}

export const productDisplayFilter = payload => {
    return {
        type: PRODUCT_DISPLAY_FILTER,
        payload
    }
}

export const productAmountFilter = payload => {
    return {
        type: PRODUCT_AMOUNT_FILTER,
        payload
    }
}

export const productSaleMonth = payload => {
    return {
        type: PRODUCT_SALE_MONTH,
        payload
    }
}

export const productNewProduct = payload => {
    return {
        type: PRODUCT_NEW_PRODUCT,
        payload
    }
}

export const productDisplaySalesmanFilter = payload => {
    return {
        type: PRODUCT_DISPLAYSALESMAN_FILTER,
        payload
    }
}

export const productProductGroupFocusFilter = payload => {
    return {
        type: PRODUCT_PRODUCTGROUP_FOCUS_FILTER,
        payload
    }
}

export const productProductLineFocusFilter = payload => {
    return {
        type: PRODUCT_PRODUCTLINE_FOCUS_FILTER,
        payload
    }
}

export const productProductTypeFocusFilter = payload => {
    return {
        type: PRODUCT_PRODUCTTYPE_FOCUS_FILTER,
        payload
    }
}

export const productSetSearchTrigger = trigger => {
    return {
        type: PRODUCT_SEARCH_TRIGGER,
        payload: trigger
    }
}